import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory, Link } from 'react-router-dom';

// ------ Composant Alerte (toast en haut à droite) -------
const Alert = ({ type, message, onClose }) => {
  if (!message) return null;
  const styles = {
    position: "fixed",
    top: "28px",
    right: "24px",
    zIndex: 9999,
    minWidth: "250px",
    maxWidth: "340px",
    padding: "14px 18px 14px 18px",
    borderRadius: "12px",
    fontWeight: 600,
    fontSize: "1rem",
    boxShadow: "0 2px 16px rgba(0,0,0,0.11)",
    display: "flex",
    alignItems: "center",
    color: type === "success" ? "#15803d" : "#c0262d",
    background: type === "success" ? "#e9f9ef" : "#ffeaea",
    border: `1.5px solid ${type === "success" ? "#22c55e" : "#ff3b3b"}`,
    animation: "pop-bounce .7s",
    transition: "opacity .3s"
  };
  return (
    <div style={styles}>
      <span style={{ flex: 1 }}>{message}</span>
      <button onClick={onClose} style={{
        background: "transparent",
        border: "none",
        color: "#888",
        fontSize: "1.25rem",
        fontWeight: 700,
        cursor: "pointer",
        marginLeft: "12px"
      }} aria-label="Fermer">×</button>
      <style>{`
        @keyframes pop-bounce {
          0% { transform: scale(0.9); opacity: 0.7;}
          70% { transform: scale(1.06);}
          100% { transform: scale(1); opacity: 1;}
        }
      `}</style>
    </div>
  );
};

// ------ Composant Modale de Confirmation -------
const ConfirmModal = ({ show, message, onConfirm, onCancel }) => {
  if (!show) return null;
  return (
    <div style={{
      position: "fixed",
      zIndex: 10000,
      left: 0, top: 0, right: 0, bottom: 0,
      background: "rgba(40,44,62,0.22)",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 14,
        maxWidth: 370,
        width: "90%",
        boxShadow: "0 8px 32px rgba(0,0,0,0.13)",
        padding: "32px 22px 18px 22px",
        textAlign: "center",
        animation: "pop-bounce .6s"
      }}>
        <div style={{ fontSize: "1.13rem", color: "#2d334d", marginBottom: 18, fontWeight: 600 }}>{message}</div>
        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
          <button onClick={onCancel} style={{
            padding: "10px 20px", borderRadius: 8, background: "#f3f4f6",
            color: "#2d334d", fontWeight: 700, border: "none", fontSize: "1rem", cursor: "pointer"
          }}>Annuler</button>
          <button onClick={onConfirm} style={{
            padding: "10px 20px", borderRadius: 8, background: "#ff5656",
            color: "#fff", fontWeight: 700, border: "none", fontSize: "1rem", cursor: "pointer"
          }}>Confirmer</button>
        </div>
        <style>{`
          @keyframes pop-bounce {
            0% { transform: scale(0.95); opacity: 0.6;}
            70% { transform: scale(1.05);}
            100% { transform: scale(1); opacity: 1;}
          }
        `}</style>
      </div>
    </div>
  );
};

// ------ TON COMPOSANT PRINCIPAL -------
const StatutDemande = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [showConfirm, setShowConfirm] = useState(false);
  const history = useHistory();

  // Fonction déclenchée par le bouton (affiche la modale)
  const demanderAnnulation = () => setShowConfirm(true);

  // Quand l'utilisateur confirme dans la modale
  const handleConfirmAnnulation = async () => {
    setShowConfirm(false);
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(
        'https://appapi.unpaidfinancial.com/api/demande/annuler',
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        }
      );
      setUser({ ...user, statut: 'attente_annulation' });
      setAlert({ type: "success", message: "Votre demande d'annulation a bien été prise en compte et sera analysée par l'administrateur." });
    } catch (e) {
      setAlert({ type: "error", message: "Erreur lors de la demande d’annulation." });
      console.error(e);
    }
  };

  // Récupération de l'utilisateur
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        if (!token) {
          setError("Aucun token trouvé. Veuillez vous connecter.");
          setLoading(false);
          return;
        }
        const response = await axios.get('https://appapi.unpaidfinancial.com/api/me', {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        });
        setUser(response.data);
      } catch (err) {
        setError('Erreur lors de la récupération des informations utilisateur.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, []);

  // Auto-hide l'alerte après 3.2s
  useEffect(() => {
    if (alert.message) {
      const timer = setTimeout(() => setAlert({ type: "", message: "" }), 3200);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  // Style badge statut
  const getStatutStyle = (statut) => {
    let base = {
      padding: "7px 24px",
      borderRadius: "25px",
      fontWeight: 700,
      fontSize: "1rem",
      display: "inline-block",
      minWidth: "110px",
      textAlign: "center",
      letterSpacing: "1px",
      marginLeft: "15px"
    };
    if (!statut) return { ...base, background: "#eee", color: "#777" };
    if (statut.toLowerCase().includes("valid")) {
      return { ...base, background: "#e9f9ef", color: "#22c55e", border: "1.5px solid #22c55e" };
    }
    if (statut.toLowerCase().includes("refus")) {
      return { ...base, background: "#ffeaea", color: "#ff3b3b", border: "1.5px solid #ff5656" };
    }
    // Par défaut "en attente"
    return { ...base, background: "#fff8e2", color: "#f59e0b", border: "1.5px solid #fbbf24" };
  };

  const getInitials = (nom, prenom) => {
    if (!nom && !prenom) return "?";
    return (
      (prenom ? prenom[0] : "") +
      (nom ? nom[0] : "")
    ).toUpperCase();
  };

  const isValide = (statut) => {
    if (!statut) return false;
    const str = statut.toLowerCase();
    return str.includes("valid") || str.includes("approuv");
  };

  if (loading) return <div style={styles.loading}>Chargement…</div>;
  if (error) return <div style={styles.error}>{error}</div>;
  if (!user) return <div style={styles.noData}>Aucune donnée utilisateur disponible.</div>;
  const showCancelButton = user.statut !== "attente_annulation" && user.statut !== "annulé";

  return (
    <div style={styles.bg}>
      <Alert
        type={alert.type === "success" ? "success" : "error"}
        message={alert.message}
        onClose={() => setAlert({ type: "", message: "" })}
      />
      <ConfirmModal
        show={showConfirm}
        message={
          <>Êtes-vous sûr de vouloir annuler votre demande ?<br /><br />
          <b style={{ color: "#ff5656" }}>La validation de cette action entraînera la suppression définitive de votre compte ainsi que de toutes vos informations sur la plateforme.<br/>Cette opération est irréversible.</b>
          </>
        }
        onConfirm={handleConfirmAnnulation}
        onCancel={() => setShowConfirm(false)}
      />
      <div style={styles.container}>
        <h2 style={styles.welcome}>
          Bienvenue {user.prenom} {user.nom}
        </h2>
        <div style={styles.card}>
          <div style={styles.avatarBlock}>
            <div style={styles.avatar}>{getInitials(user.nom, user.prenom)}</div>
          </div>
          <div style={styles.infoSection}>
            <div style={styles.infoRow}>
              <i className="fas fa-user" style={styles.icon}></i>
              <span><strong>Nom :</strong> {user.nom}</span>
            </div>
            <div style={styles.infoRow}>
              <i className="fas fa-user" style={styles.icon}></i>
              <span><strong>Prénom :</strong> {user.prenom}</span>
            </div>
            <div style={styles.infoRow}>
              <i className="fas fa-home" style={styles.icon}></i>
              <span><strong>Adresse résidentielle :</strong> {user.adresse || "-"}</span>
            </div>
            <div style={styles.infoRow}>
              <i className="fas fa-hand-holding-usd" style={styles.icon}></i>
              <span><strong>Type d'aide :</strong> {user.typeAide|| "-"}</span>
            </div>
            <div style={styles.infoRow}>
              <i className="fas fa-globe-africa" style={styles.icon}></i>
              <span><strong>Pays :</strong> {user.pays}</span>
              <span style={styles.dot}>•</span>
              <span><strong>Ville :</strong> {user.ville}</span>
            </div>
            <div style={styles.infoRow}>
              <i className="fas fa-info-circle" style={styles.icon}></i>
              <span>
                <strong>Statut :</strong>
                <span style={getStatutStyle(user.statut)}>
                  {user.statut?.charAt(0).toUpperCase() + user.statut?.slice(1)}
                </span>
              </span>
            </div>
            {isValide(user.statut) && (
              <div style={styles.validMessageBox}>
                <span style={styles.validMessage}>
                  Votre demande a été <b>confirmée</b>, contactez votre gestionnaire{" "}
                  <Link
                    to="/me/contactus"
                    style={styles.contactLink}
                  >ici</Link>
                  .
                </span>
              </div>
            )}
          </div>
        </div>
        {showCancelButton && (
          <div style={{ textAlign: "center", marginTop: 22 }}>
            <button
              onClick={demanderAnnulation}
              style={{
                padding: "11px 32px",
                borderRadius: "28px",
                background: "#ff5656",
                color: "#fff",
                fontWeight: 700,
                border: "none",
                fontSize: "1rem",
                cursor: "pointer",
                boxShadow: "0 4px 16px rgba(255,86,86,0.14)",
                transition: "background .18s"
              }}
            >
              Annuler ma demande
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  bg: {
    minHeight: '100vh',
    background: '#f6f7fb',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '32px 0'
  },
  container: {
    width: '100%',
    maxWidth: '540px',
    margin: '0 auto'
  },
  welcome: {
    fontSize: '2.1rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '28px',
    color: '#31314e',
    letterSpacing: '.5px'
  },
  card: {
    width: '100%',
    background: '#fff',
    borderRadius: '18px',
    boxShadow: '0 8px 32px 0 rgba(44, 44, 92, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '34px 24px 28px 24px',
    animation: 'fade-in 1s',
  },
  avatarBlock: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px'
  },
  avatar: {
    width: '90px',
    height: '90px',
    background: 'linear-gradient(135deg, #7f53ac 0%, #647dee 100%)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontWeight: 700,
    fontSize: '2.5rem',
    boxShadow: '0 4px 16px rgba(100, 125, 238, 0.2)',
    marginBottom: '12px',
  },
  infoSection: {
    width: '100%',
    marginTop: '10px'
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '13px',
    fontSize: '1.11rem',
    marginBottom: '15px',
    color: '#4e4e4e',
    fontWeight: 500
  },
  icon: {
    color: '#647dee',
    fontSize: '1.14rem',
    minWidth: '22px'
  },
  dot: {
    fontSize: '1.2rem',
    margin: '0 7px',
    color: '#bdbdbd',
    fontWeight: 'bold',
    verticalAlign: 'middle',
  },
  loading: {
    textAlign: 'center',
    fontSize: '26px',
    marginTop: '15vh',
    color: '#fa709a',
    letterSpacing: '2px',
  },
  error: {
    textAlign: 'center',
    fontSize: '22px',
    color: 'red',
    marginTop: '15vh',
  },
  noData: {
    textAlign: 'center',
    fontSize: '22px',
    marginTop: '15vh',
    color: '#666',
  },
  validMessageBox: {
    marginTop: '24px',
    textAlign: 'center',
    background: '#e9f9ef',
    border: '1.5px solid #22c55e',
    borderRadius: '14px',
    padding: '16px 12px 13px 12px',
    boxShadow: '0 2px 8px rgba(34,197,94,0.06)',
    fontSize: '1.11rem',
    fontWeight: 600
  },
  validMessage: {
    color: '#15803d',
    fontWeight: 600,
    fontSize: '1.07rem',
    letterSpacing: '.7px'
  },
  contactLink: {
    color: '#000',
    borderRadius: '6px',
    padding: '4px 18px',
    textDecoration: 'none',
    fontWeight: 700,
    margin: '0 7px',
    fontSize: '1.06rem',
    boxShadow: '0 2px 7px rgba(36,197,94,0.10)',
    transition: 'background 0.15s, color 0.18s',
    border: 'none',
    outline: 'none'
  }
};

export default StatutDemande;
